const notificationBanner = document.querySelectorAll('.js-notification-banner');
const menuHamburger = document.querySelector('.js-hamburger');
const closeBtn = document.querySelectorAll('.js-close-btn');

if (notificationBanner) {
  menuHamburger.addEventListener('click', () => {
    [...notificationBanner].forEach((item) =>
    {
      item.classList.toggle('js-menu-active');
    });
  });
}

if (notificationBanner) {
  [...closeBtn].forEach((item) =>
  {
    item.addEventListener("click", event =>
    {
      item.parentNode.classList.add("js-deactive");
    });
  });
}
